import React, { useState } from 'react';
import '../components-styles/club-enquiry-form.css';

function ClubEnquiryForm() {
  const [formData, setFormData] = useState({
    club_name: '',
    contact_person: '',
    position: '',
    email: '',
    phone: '',
    enquiry_type: '',
    player_position_needed: '',
    budget_range: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000/api'}/club-submissions/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to submit form');
      }

      setSubmitted(true);
      setFormData({
        club_name: '',
        contact_person: '',
        position: '',
        email: '',
        phone: '',
        enquiry_type: '',
        player_position_needed: '',
        budget_range: '',
        message: ''
      });
      
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (err) {
      setError(err.message || 'An error occurred while submitting the form');
      console.error('Submission error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="club-enquiry-form" onSubmit={handleSubmit}>
      {submitted && <div className="success-message">✓ Enquiry submitted successfully! We'll review your request and contact you shortly.</div>}
      {error && <div className="error-message">✗ Error: {error}</div>}

      <div className="form-group">
        <label htmlFor="club_name">Club Name *</label>
        <input
          type="text"
          id="club_name"
          name="club_name"
          value={formData.club_name}
          onChange={handleChange}
          required
          placeholder="Your club name"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="contact_person">Contact Person *</label>
          <input
            type="text"
            id="contact_person"
            name="contact_person"
            value={formData.contact_person}
            onChange={handleChange}
            required
            placeholder="Your name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="position">Position / Role</label>
          <input
            type="text"
            id="position"
            name="position"
            value={formData.position}
            onChange={handleChange}
            placeholder="e.g., Director of Football, Head Coach"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="your@email.com"
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone *</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            placeholder="+44..."
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="enquiry_type">Enquiry Type *</label>
        <select
          id="enquiry_type"
          name="enquiry_type"
          value={formData.enquiry_type}
          onChange={handleChange}
          required
        >
          <option value="">Select...</option>
          <option value="Player Sourcing">Player Sourcing</option>
          <option value="Recruitment Support">Recruitment Support</option>
          <option value="Transfer Advisory">Transfer Advisory</option>
          <option value="Loan Opportunities">Loan Opportunities</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="player_position_needed">Position(s) Required *</label>
          <input
            type="text"
            id="player_position_needed"
            name="player_position_needed"
            value={formData.player_position_needed}
            onChange={handleChange}
            required
            placeholder="e.g., Strikers, Midfielders, Defenders"
          />
        </div>
        <div className="form-group">
          <label htmlFor="budget_range">Budget Range (Optional)</label>
          <input
            type="text"
            id="budget_range"
            name="budget_range"
            value={formData.budget_range}
            onChange={handleChange}
            placeholder="e.g., £500k - £2m or Loan preferred"
          />
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="message">Additional Information</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Tell us more about your club's needs, preferred playing style, and any other relevant information..."
          rows="4"
        ></textarea>
      </div>

      <button type="submit" className="submit-btn" disabled={submitting}>
        {submitting ? 'Submitting...' : 'Submit Enquiry'}
      </button>
    </form>
  );
}

export default ClubEnquiryForm;
